import { render, staticRenderFns } from "./PersistPosicaoMotoristaView.vue?vue&type=template&id=6bf0bcb3&"
import script from "./PersistPosicaoMotoristaView.vue?vue&type=script&lang=ts&"
export * from "./PersistPosicaoMotoristaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports